import Navbar from "./Navbar";
import Page from "./Page";
const Home = () => {
    return ( 
        <main>
            <Navbar />
            <Page />
        </main>
     );
}
 
export default Home;